import React, { useEffect, useMemo, useState } from "react";
import "./PendingVerifications.css";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export default function PendingVerificationsMembers() {
  const localUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);

  const [members, setMembers]       = useState([]);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState("");
  const [actionMsg, setActionMsg]   = useState({ type: "", text: "" });
  const [processing, setProcessing] = useState(new Set());

  const fetchPending = async () => {
    setLoading(true);
    setError("");
    setActionMsg({ type: "", text: "" });
    try {
      const res  = await fetch(`${API_ROOT}/api/guesthouse/pending-verifications-members?moduleId=${moduleId}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load pending verifications");
      setMembers(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      setError(err.message || "Failed to load pending verifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (moduleId !== 10) return;
    fetchPending();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  const handleAction = async (memberId, status, mobile, selectEl) => {
    const label = status === "Y" ? "Approve" : "Reject";
    if (!window.confirm(`${label} member registration?`)) {
      selectEl.value = "";
      return;
    }

    setProcessing(prev => new Set(prev).add(memberId));
    setActionMsg({ type: "", text: "" });

    try {
      const res = await fetch(`${API_ROOT}/api/guesthouse/pending-verifications-members/update-status`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ moduleId, memberId, status, mobile })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to update status");

      setActionMsg({ type: "success", text: data.message || "Status updated." });
      setMembers(prev => prev.filter(m => m.GHMemberID !== memberId));
    } catch (err) {
      setActionMsg({ type: "error", text: err.message || "Failed to update status." });
      setProcessing(prev => {
        const next = new Set(prev);
        next.delete(memberId);
        return next;
      });
      selectEl.value = "";
    }
  };

  if (moduleId !== 10) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Pending Verification of Fellows / Members</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      {actionMsg.text && (
        <div className={`alert alert-${actionMsg.type === "success" ? "success" : "danger"}`}>
          {actionMsg.text}
        </div>
      )}

      {loading ? (
        <div className="text-muted">Loading...</div>
      ) : !error && members.length === 0 ? (
        <div className="alert alert-info">No pending member verifications found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle pending-verif-table">
            <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
              <tr>
                <th>SNo</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Member Type</th>
                <th>Doc</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m, idx) => (
                <tr key={m.GHMemberID}>
                  <td>{idx + 1}</td>
                  <td>{m.MemberName}</td>
                  <td>{m.Mobile}</td>
                  <td>{m.MemberType}</td>
                  <td>
                    {m.hasDoc ? (
                      <button
                        className="btn btn-sm btn-outline-info"
                        onClick={() =>
                          window.open(
                            `${API_ROOT}/api/guesthouse/member-doc/${m.GHMemberID}?moduleId=${moduleId}`,
                            "_blank"
                          )
                        }
                      >
                        View
                      </button>
                    ) : (
                      <span style={{ color: "red" }}>NoDoc</span>
                    )}
                  </td>
                  <td>
                    <select
                      className="form-select form-select-sm"
                      defaultValue=""
                      disabled={processing.has(m.GHMemberID)}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!val) return;
                        handleAction(m.GHMemberID, val, m.Mobile, e.target);
                      }}
                    >
                      <option value="" disabled>Status</option>
                      <option value="Y">Approved</option>
                      <option value="R">Rejected</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
